// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__S0IIf","btn":"NotFound_btn__Hwr+7"};